var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInputSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_203_8311)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.692383 7.56767C0.692383 3.77052 3.77059 0.692322 7.56775 0.692322C11.3649 0.692322 14.4431 3.77052 14.4431 7.56767C14.4431 11.3648 11.3649 14.443 7.56775 14.443C3.77059 14.443 0.692383 11.3648 0.692383 7.56767Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2741 13.274C13.4978 13.0502 13.8606 13.0502 14.0843 13.274L17.14 16.3296C17.3637 16.5534 17.3637 16.9161 17.14 17.1399C16.9162 17.3636 16.5534 17.3636 16.3297 17.1399L13.274 14.0842C13.0503 13.8605 13.0503 13.4977 13.2741 13.274Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.77203 2.94147C6.82153 3.254 6.6083 3.54749 6.29576 3.59699C4.90653 3.81702 3.81697 4.90658 3.59693 6.29582C3.54743 6.60835 3.25394 6.82158 2.94141 6.77208C2.62888 6.72258 2.41565 6.42909 2.46515 6.11656C2.76284 4.237 4.23695 2.7629 6.11651 2.46521C6.42904 2.41571 6.72253 2.62894 6.77203 2.94147Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_203_8311"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputSearch);
export default __webpack_public_path__ + "static/media/input-search.f01d8e34e51df36f570d81ece31d4fd7.svg";
export { ForwardRef as ReactComponent };